module.exports = __webpack_public_path__ + "static/img/UBC校区.b0d6ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC校区.png
// module id = gzRA
// module chunks = 0